'use strict'
import OrderTableByState from './OrderTableByState'

export default function OrderTableInviati() {
  return <OrderTableByState states={[1, 2]} title="Ordini Inviati" />
}
